import { useGetGroupQuery } from '@entities/clients/rtk-query.ts';
import { useGroup } from '@entities/common/groups';
import { useEffect } from 'react';

export const useGroupLoader = (id: number) => {
  const { setGroup } = useGroup(id);

  const { data, isLoading, isFetching } = useGetGroupQuery(id, { skip: !id || isNaN(id) });

  useEffect(() => {
    data && setGroup(data);
  }, [data, setGroup]);

  return {
    isLoading: isLoading || isFetching,
    group: data,
  };
};
